import { defineComponent as _defineComponent } from 'vue'
export interface Props {
  item: Invite;
}


import { computed } from 'vue';
import { isBefore, isAfter } from 'date-fns';

import type { Invite } from '@models';
import { dateFilter } from '@filters/date';
const TEXT_COLOR_GRAY = '#363b47';
const BG_COLOR_GRAY = '#9fa5b3';

const TEXT_COLOR_GREEN = '#004546';
const BG_COLOR_GREEN = '#37da88';

const TEXT_COLOR_RED = '#5d0029';
const BG_COLOR_RED = '#ff4f80';

declare module '@vue/runtime-core' {
  export interface GlobalComponents {
    TableCellInviteStatus: ComponentWithProps<Props>;
  }
}

interface StatusDisplayConfig {
  text: string;
  color: string;
  backgroundColor: string;
}

/** Display config info for certification status label. */
const STATUS_DISPLAY_CONFIGS = {
  AWAITING_RESPONSE: {
    text: 'Awaiting Response',
    color: TEXT_COLOR_GRAY,
    backgroundColor: BG_COLOR_GRAY,
  },
  DECLINED: {
    text: 'Declined',
    color: TEXT_COLOR_RED,
    backgroundColor: BG_COLOR_RED,
  },
  ACCEPTED: {
    text: 'Accepted',
    color: TEXT_COLOR_GREEN,
    backgroundColor: BG_COLOR_GREEN,
  },
  EXPIRED: {
    text: 'Expired',
    color: TEXT_COLOR_RED,
    backgroundColor: BG_COLOR_RED,
  },
  SENT: {
    text: 'Sent',
    color: TEXT_COLOR_GRAY,
    backgroundColor: BG_COLOR_GRAY,
  },
  WAITING_TO_SEND: {
    text: 'Send On ',
    color: TEXT_COLOR_GRAY,
    backgroundColor: BG_COLOR_GRAY,
  },
} satisfies Record<string, StatusDisplayConfig>;

export default /*#__PURE__*/_defineComponent({
  __name: 'TableCellInviteStatus',
  props: {
    item: null
  },
  setup(__props: any) {

const props = __props as {
  item: Invite;
};

/**
 * `TableCellInviteStatus` component properties.
 */


const formattedDate = computed(() => {
  if (!props.item.sendDate) return 'N/A';
  const date = new Date(props.item.sendDate);
  return dateFilter(date.toISOString(), 'MM/dd/yyyy');
});

const displayConfig = computed(() => {
  if (
    !props.item.sent &&
    props.item.sendDate &&
    isBefore(new Date(), new Date(props.item.sendDate))
  ) {
    return {
      ...STATUS_DISPLAY_CONFIGS.WAITING_TO_SEND,
      text: `Send On ${formattedDate.value as string}`,
    };
  }

  if (props.item.sent && !props.item.accepted && !props.item.used) {
    return STATUS_DISPLAY_CONFIGS.SENT;
  }

  if (
    !props.item.accepted &&
    !props.item.used &&
    isAfter(new Date(), new Date(props.item.expirationDate))
  ) {
    return STATUS_DISPLAY_CONFIGS.EXPIRED;
  }

  return props.item.accepted
    ? STATUS_DISPLAY_CONFIGS.ACCEPTED
    : props.item.used
    ? STATUS_DISPLAY_CONFIGS.DECLINED
    : STATUS_DISPLAY_CONFIGS.AWAITING_RESPONSE;
});

const text = computed(() => {
  return displayConfig.value.text;
});

const style = computed(() => {
  return {
    color: displayConfig.value.color,
    backgroundColor: displayConfig.value.backgroundColor,
  };
});

return { __sfc: true,TEXT_COLOR_GRAY, BG_COLOR_GRAY, TEXT_COLOR_GREEN, BG_COLOR_GREEN, TEXT_COLOR_RED, BG_COLOR_RED, STATUS_DISPLAY_CONFIGS, props, formattedDate, displayConfig, text, style }
}

})